module.exports = __webpack_public_path__ + "img/mb-focus-head-bg.1225e94b.jpg";